import { render, staticRenderFns } from "./ProductNavigator.vue?vue&type=template&id=a1a3108a&scoped=true"
import script from "./ProductNavigator.vue?vue&type=script&lang=js"
export * from "./ProductNavigator.vue?vue&type=script&lang=js"
import style0 from "./ProductNavigator.vue?vue&type=style&index=0&id=a1a3108a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a3108a",
  null
  
)

export default component.exports